import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getHighestFamilyPermission(
  level1: string | null | undefined,
  level2: string | null | undefined
): 'view_only' | 'can_complete' | 'can_hide' {
  const hierarchy = {
    'view_only': 1,
    'can_complete': 2,
    'can_hide': 3
  };
  
  const normalized1 = level1 || 'view_only';
  const normalized2 = level2 || 'view_only';
  
  return hierarchy[normalized1 as keyof typeof hierarchy] >= hierarchy[normalized2 as keyof typeof hierarchy] 
    ? normalized1 as 'view_only' | 'can_complete' | 'can_hide'
    : normalized2 as 'view_only' | 'can_complete' | 'can_hide';
}
